import styled from "@emotion/styled";
import React from "react";
import { Shimmer } from "react-shimmer";
import ChatMessageImageWithPreview from "./ChatMessageImageWithPreview";

interface Props {
  src: string;
  urlWithoutQuery: string;
  imagePreview: string | null;
  onRequestImagePreview: (image: string | null) => void;
}

const size = 200;

function ChatMessageImage(props: Props) {
  const fallback = <ChatMessageImage.Fallback height={size} width={size} />;

  return (
    <ChatMessageImage.Root>
      {props.src.startsWith("s3://") ? (
        fallback
      ) : (
        <ChatMessageImageWithPreview
          url={props.src}
          urlWithoutQuery={props.urlWithoutQuery}
          isSelected={props.urlWithoutQuery === props.imagePreview}
          size={size}
          fallback={fallback}
          onSelectImage={props.onRequestImagePreview}
        />
      )}
    </ChatMessageImage.Root>
  );
}

ChatMessageImage.Root = styled.div``;

ChatMessageImage.Fallback = styled(Shimmer)`
  border-radius: 12px;
`;

export default ChatMessageImage;
